import {Component, Input, OnInit, Optional} from '@angular/core';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {ProductService} from '../../services/product.service';
import {ITableHeader} from '../../../interfaces/table-header';
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {ProductType} from '../../utils/product';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {FormService} from "../../services/form.service";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";
import {GuardService} from '../../services/guard.service';

@Component({
  selector: 'table-product',
  templateUrl: './table-product.component.html',
  providers: [LoaderService]
})
export class TableProductComponent extends TableEntityExtension implements OnInit {

  storeData: any;
  @Input('store') set store$(value: any) {
    if (value) {
      this.storeData = value;
      this.handleHeaders(value, 'parentStore', 'store');
    }
  }

  ProductType = ProductType;
  types: any = [
    ProductType.Subscription,
    ProductType.Consumable,
    ProductType.NonConsumable
  ];

  headers: ITableHeader[];

  query: any = {
    filters: {},
   order: null,
    relations: ['parentStore', 'project', 'storeCollection']
  };

  entities: any = [{
    label: 'Project',
    key: 'project'
  }, {
    label: 'Collection',
    key: 'storeCollection'
  }];

  forms: any = {};
  subscriptions: Subscription[] = [];

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: ProductService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private formService: FormService,
              private tableHeaderService: TableHeaderService,
              private guardService: GuardService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.headers = [
      this.tableHeaderService.id(),
      this.tableHeaderService.type(),
      this.tableHeaderService.store({filter: {key: 'parentStore'}, sort: {key: 'parentStore'}}),
      this.tableHeaderService.subject({sort: false, filter: false}),
      this.tableHeaderService.innerProduct(),
      this.tableHeaderService.createdAt(),
      // this.tableHeaderService.actions(),
    ];
    if (this.storeData)
      this.handleHeaders(this.storeData, 'parentStore', 'store');

    this.checkChanges();
    this.routesInit('products');
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.subscriptions.forEach(item => item.unsubscribe());
  }

  async initForm(itemCollapse: any) {
    const skipChanges = await this.guardService.skipChanges();

    if (!skipChanges || itemCollapse.result) return;

    const item = this.source[itemCollapse.position];

    if (item.project) item.entity = 'project';
    else if (item.storeCollection) item.entity = 'storeCollection';

    const form = this.forms[item.id] = new FormBuilder().group({
      name: ['', Validators.required],
      googleProductId: ['', Validators.required],
      appleProductId: ['', Validators.required],
      innerProduct: [],
      type: [null, Validators.required],
    });

    const subscriptionForm = {
      subscriptionPeriod: new FormControl(null, [Validators.required]),
    };

    const consumableForm = {
      coinsValue: new FormControl(null, [Validators.required]),
    };

    const nonConsumableForm = {
      entity: new FormControl(null, [Validators.required]),
      project: new FormControl(),
      storeCollection: new FormControl(),
    };

    const costForm = {
      coinsCost: new FormControl(null, [Validators.required]),
    };

    this.subscriptions.push(
      form.get('type').valueChanges.subscribe((result) => {
        this.formService.toggleControls(form, subscriptionForm, result === ProductType.Subscription, item);
        this.formService.toggleControls(form, consumableForm, result === ProductType.Consumable, item);
        this.formService.toggleControls(form, nonConsumableForm, result === ProductType.NonConsumable, item);
      })
    );

    this.subscriptions.push(
      form.get('innerProduct').valueChanges.subscribe((result) => {
        this.formService.toggleControls(form, costForm, result, item);
      })
    );

    form.patchValue(item);
    this.formService.setDefaultValues(form);
    this.formService.setActiveForms([form]);

    itemCollapse.next();
  }


  async cancel(collapse) {
    const skipChanges = await this.guardService.skipChanges();
    if (skipChanges) this.formService.setForceSkipCheck()
    if (!skipChanges || collapse.result) return;

    collapse.toggle();
  }
}
